import { Skeleton } from '@fe-learner-common';
import { Page } from '@fe-learner-common/Page';
import { CourseCardGrid } from '@routes/catalog/components/CourseCardGrid';
import { useConfigContext } from '@fe-core';

const CategoriesSkeleton = () => {
  return (
    <div className="lf:flex lf:w-full lf:flex-nowrap lf:gap-2 lf:overflow-hidden lf:p-3 ">
      {Array.from({ length: 12 }).map((_, index) => (
        <Skeleton key={index} className="lf:min-w-[100px]" type="button" />
      ))}
    </div>
  );
};

const CardSkeleton = () => (
  <div className="lf:flex lf:h-full lf:cursor-pointer lf:flex-col lf:gap-3 lf:rounded-2xl lf:p-3 lf:sm:m-0 lf:sm:size-auto">
    <Skeleton type="card" />
    <Skeleton type="text" className="lf:h-[24px] lf:w-3/4" />
  </div>
);

const CardSkeletons = () => {
  return (
    <CourseCardGrid>
      {Array.from({ length: 12 }).map((_, index) => (
        <CardSkeleton key={index} />
      ))}
    </CourseCardGrid>
  );
};

export const CatalogSkeleton = () => {
  const { config } = useConfigContext();
  return (
    <div className="lf:overflow-y-scroll">
      {!config.webfeatures?.['nextgenui-default'] && (
        <Skeleton
          type="text"
          className="lf:h-[40px] lf:w-full lf:rounded-none lf:bg-prominence-50"
        />
      )}

      <Page className="lf:flex lf:flex-col lf:gap-3 ">
        <div className="lf:md:space-y-3">
          <div className="lf:flex lf:items-center lf:gap-2 lf:px-4 lf:pb-3">
            <Skeleton type="text" className="lf:me-auto lf:h-[30px] lf:w-[200px] " />
            <Skeleton type="text" className=" lf:h-[30px] lf:w-[100px]" />
            <Skeleton type="text" className=" lf:h-[30px] lf:w-[100px]" />
            <Skeleton type="text" className="" />
          </div>
          <CategoriesSkeleton />

          <CardSkeletons />
        </div>
      </Page>
    </div>
  );
};
